var am4YearSlider = require('./components/yearslider');

var currentYear;

function updateData(chart, year, yearLabel, series, seriesData) {
	if (currentYear !== year) {
		currentYear = year;

		for (var i = 0; i < series.length; i++) {
			// Check if data for current year exists
			if (seriesData[i].Name + year in chart.data[0]) {
				series[i].dataFields.valueX = seriesData[i].Name + year;
				yearLabel.text = currentYear;
			}
		}

		chart.invalidateRawData();
	}
}

function animate(yearSlider) {
	var sliderAnimation = yearSlider.animate({ property: 'start', to: 1, from: 0 },
		5000, window.am4core.ease.linear).pause();
	sliderAnimation.start();
}

module.exports = {
	createAnimatedBarChart: function (chart, seriesData, valueAxis, yearData, $graphblock) {
		var series = chart.series.values;
		var stepDuration = 1500;
		valueAxis.rangeChangeDuration = stepDuration;

		for (var i = 0; i < series.length; i++) {
			series[i].interpolationDuration = stepDuration;
		}

		if (!seriesData[0].AutoScale) {
			valueAxis.strictMinMax = true;
			valueAxis.min = seriesData[0].MinValue > 0 ? 0 : seriesData[0].MinValue;
			valueAxis.max = seriesData[0].MaxValue;
		}

		var yearSlider = am4YearSlider.createYearSlider(chart, yearData, series, seriesData, "", updateData, 0);

		$(window).on('scroll', function scrollHandler() {
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $graphblock.offset().top;
			var elemBottom = elemTop + $graphblock.height();

			if ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) {
				animate(yearSlider);
				$(window).off('scroll', scrollHandler);
			}
		});
	}
};
